import { render, staticRenderFns } from "./HotCard.vue?vue&type=template&id=538b3ba8&scoped=true"
import script from "./HotCard.vue?vue&type=script&lang=js"
export * from "./HotCard.vue?vue&type=script&lang=js"
import style0 from "./HotCard.vue?vue&type=style&index=0&id=538b3ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b3ba8",
  null
  
)

export default component.exports